export const projects = [
  {
    title: "Using JS and DB",
    subtitle: "Newsletter signup",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./sid.png",
    link: "https://whispering-reef-29535.herokuapp.com/",
  },
  {
    title: "React Tracks",
    subtitle: "React and Python",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./project-2.gif",
    link: "https://reactbootcamp.com",
  },
  {
    title: "Note keeping App",
    subtitle: "React",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./sid2.png",
    link: "https://qf870m.csb.app/",
  },
  {
    title: "Epic Todo App",
    subtitle: "React Hooks",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./sid3.png",
    link: "https://calm-mesa-85426.herokuapp.com/",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "./xavier.jpeg",
    name: "Xavier",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "./meme2.jpeg",
    name: "Shaquille 0' Neile",
    company: "Dooble.io",
  },
];

export const skills = [
  "JavaScript",
  "React",
  "Next.js",
  "Node",
  "Tailwind",
  "Material UI/Bootstrap",
];



// WEBPACK FOOTER //
// ./src/data.js